webpackJsonp([3,5],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getFocusabledIn = exports.newFocus = undefined;var _map = __webpack_require__(659);var _map2 = _interopRequireDefault(_map);var _DOMutils = __webpack_require__(1027);
var _firstFocus = __webpack_require__(1031);var _firstFocus2 = _interopRequireDefault(_firstFocus);
var _allAffected = __webpack_require__(989);var _allAffected2 = _interopRequireDefault(_allAffected);
var _array = __webpack_require__(976);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
  };
};

var isGuard = function isGuard(node) {
  return node && node.dataset && node.dataset.focusGuard;
};
var notAGuard = function notAGuard(node) {
  return !isGuard(node);
};

var newFocus = exports.newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);

  // focus is inside
  if (innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }

  var activeIndex = outerNodes.indexOf(activeElement);
  var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
  var lastNodeInside = innerNodes.indexOf(lastNode);
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);

  var returnFirstNode = (0, _firstFocus.pickFocusable)(innerNodes, 0);
  var returnLastNode = (0, _firstFocus.pickFocusable)(innerNodes, cnt - 1);

  // new focus
  if (activeIndex === -1 || lastNodeInside === -1) {
    return innerNodes.indexOf(autoFocused && autoFocused.length ? (0, _firstFocus2.default)(autoFocused) : (0, _firstFocus2.default)(innerNodes));
  }
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // first element
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  // last element
  if (activeIndex >= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  // jump out, but not on the guard
  if (indexDiff && Math.abs(indexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};

var getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = (0, _array.asArray)(baseActiveElement);
  var leftEntries = (0, _array.asArray)(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = null;
  leftEntries.filter(Boolean).forEach(function (entry) {
    topCommon = (0, _DOMutils.getCommonParent)(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function (subEntry) {
      var common = (0, _DOMutils.getCommonParent)(activeElement, subEntry);
      if (common) {
        if (!topCommon || common.contains(topCommon)) {
          topCommon = common;
        } else {
          topCommon = (0, _DOMutils.getCommonParent)(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};

var allParentAutofocusables = function allParentAutofocusables(entries) {
  return entries.reduce(function (acc, node) {
    return acc.concat((0, _DOMutils.parentAutofocusables)(node));
  }, []);
};

var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
  var remap = new _map2.default();
  // no Set(dstNodes) for IE11 :(
  dstNodes.forEach(function (entity) {
    return remap.set(entity.node, entity);
  });
  // remap to dstNodes
  return srcNodes.map(function (node) {
    return remap.get(node);
  }).filter(Boolean);
};

var getFocusabledIn = exports.getFocusabledIn = function getFocusabledIn(topNode) {
  var entries = (0, _allAffected2.default)(topNode).filter(notAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var outerNodes = (0, _DOMutils.getTabbableNodes)([commonParent], true);
  var innerElements = (0, _DOMutils.getTabbableNodes)(entries).filter(function (_ref) {
    var node = _ref.node;
    return notAGuard(node);
  }).map(function (_ref2) {
    var node = _ref2.node;
    return node;
  });

  return outerNodes.map(function (_ref3) {
    var node = _ref3.node,
    index = _ref3.index;
    return {
      node: node,
      index: index,
      lockItem: innerElements.indexOf(node) >= 0,
      guard: isGuard(node) };

  });
};

var getFocusMerge = function getFocusMerge(topNode, lastNode) {
  var activeElement = document && document.activeElement;
  var entries = (0, _allAffected2.default)(topNode).filter(notAGuard);

  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);

  var innerElements = (0, _DOMutils.getTabbableNodes)(entries).filter(function (_ref4) {
    var node = _ref4.node;
    return notAGuard(node);
  });

  if (!innerElements[0]) {
    innerElements = (0, _DOMutils.getAllTabbableNodes)(entries).filter(function (_ref5) {
      var node = _ref5.node;
      return notAGuard(node);
    });
    if (!innerElements[0]) {
      return undefined;
    }
  }

  var outerNodes = (0, _DOMutils.getTabbableNodes)([commonParent]).map(function (_ref6) {
    var node = _ref6.node;
    return node;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerNodes = orderedInnerElements.map(function (_ref7) {
    var node = _ref7.node;
    return node;
  });

  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));

  if (newId === undefined) {
    return newId;
  }
  return orderedInnerElements[newId];
};exports.default =

getFocusMerge;

/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.hiddenGuard = undefined;var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var hiddenGuard = exports.hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px' };


var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard }),
  children, children && _react2.default.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard }));

};

InFocusGuard.propTypes =  false ? {
  children: _propTypes2.default.node } :
{};
InFocusGuard.defaultProps = {
  children: null };exports.default =

InFocusGuard;

/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1007);

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
    'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
    'Use PropTypes.checkPropTypes() to call them. ' +
    'Read more at http://fb.me/use-check-prop-types');

    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim };


  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends3 = __webpack_require__(982);var _extends4 = _interopRequireDefault(_extends3);
var _inheritsLoose2 = __webpack_require__(997);var _inheritsLoose3 = _interopRequireDefault(_inheritsLoose2);
var _assertThisInitialized2 = __webpack_require__(998);var _assertThisInitialized3 = _interopRequireDefault(_assertThisInitialized2);
var _defineProperty2 = __webpack_require__(999);var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusLock = __webpack_require__(980);
var _Trap = __webpack_require__(1035);var _Trap2 = _interopRequireDefault(_Trap);
var _FocusGuard = __webpack_require__(1001);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var RenderChildren = function RenderChildren(_ref) {
  var children = _ref.children;
  return _react2.default.createElement("div", null, children);
};

RenderChildren.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired } :
{};
var Fragment = _react2.default.Fragment ? _react2.default.Fragment : RenderChildren;
var emptyArray = [];

var FocusLock =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose3.default)(FocusLock, _Component);

  function FocusLock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "state", {
      observed: undefined });


    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "onActivation", function () {
      _this.originalFocusedElement = _this.originalFocusedElement || document && document.activeElement;

      if (_this.state.observed && _this.props.onActivation) {
        _this.props.onActivation(_this.state.observed);
      }

      _this.isActive = true;
    });

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "onDeactivation", function () {
      _this.isActive = false;

      if (_this.props.returnFocus && _this.originalFocusedElement && _this.originalFocusedElement.focus) {
        _this.originalFocusedElement.focus();

        _this.originalFocusedElement = null;
      }

      if (_this.props.onDeactivation) {
        _this.props.onDeactivation(_this.state.observed);
      }
    });

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "onFocus", function (event) {
      if (_this.isActive) {
        (0, _Trap.onFocus)(event);
      }
    });

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "onBlur", _Trap.onBlur);

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "setObserveNode", function (observed) {
      if (_this.state.observed !== observed) {
        _this.setState({
          observed: observed });

      }
    });

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "isActive", false);

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "originalFocusedElement", null);

    return _this;
  }

  var _proto = FocusLock.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
    children = _this$props.children,
    disabled = _this$props.disabled,
    noFocusGuards = _this$props.noFocusGuards,
    persistentFocus = _this$props.persistentFocus,
    autoFocus = _this$props.autoFocus,
    allowTextSelection = _this$props.allowTextSelection,
    group = _this$props.group,
    className = _this$props.className,
    whiteList = _this$props.whiteList,
    _this$props$shards = _this$props.shards,
    shards = _this$props$shards === void 0 ? emptyArray : _this$props$shards,
    _this$props$as = _this$props.as,
    Container = _this$props$as === void 0 ? 'div' : _this$props$as,
    _this$props$lockProps = _this$props.lockProps,
    containerProps = _this$props$lockProps === void 0 ? {} : _this$props$lockProps;
    var observed = this.state.observed;

    if (false) {
      if (typeof allowTextSelection !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
      }
    }

    var lockProps = (0, _extends4.default)((_extends2 = {}, _extends2[_focusLock.constants.FOCUS_DISABLED] = disabled && 'disabled', _extends2[_focusLock.constants.FOCUS_GROUP] = group, _extends2), containerProps);

    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    return _react2.default.createElement(Fragment, null, hasLeadingGuards && [_react2.default.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: _FocusGuard.hiddenGuard }),
    // nearest focus guard
    _react2.default.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: _FocusGuard.hiddenGuard })],
    _react2.default.createElement(Container, (0, _extends4.default)({
      ref: this.setObserveNode },
    lockProps, {
      className: className,
      onBlur: this.onBlur,
      onFocus: this.onFocus }),
    _react2.default.createElement(_Trap2.default, {
      observed: observed,
      disabled: disabled,
      persistentFocus: persistentFocus,
      autoFocus: autoFocus,
      whiteList: whiteList,
      shards: shards,
      onActivation: this.onActivation,
      onDeactivation: this.onDeactivation }),
    children), hasTailingGuards && _react2.default.createElement("div", {
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: _FocusGuard.hiddenGuard }));

  };

  return FocusLock;
}(_react.Component);

FocusLock.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  returnFocus: _propTypes2.default.bool,
  noFocusGuards: _propTypes2.default.bool,
  allowTextSelection: _propTypes2.default.bool,
  autoFocus: _propTypes2.default.bool,
  persistentFocus: _propTypes2.default.bool,
  group: _propTypes2.default.string,
  className: _propTypes2.default.string,
  whiteList: _propTypes2.default.func,
  shards: _propTypes2.default.arrayOf(_propTypes2.default.any),
  as: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
  lockProps: _propTypes2.default.object,
  onActivation: _propTypes2.default.func,
  onDeactivation: _propTypes2.default.func } :
{};
FocusLock.defaultProps = {
  disabled: false,
  returnFocus: false,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined };exports.default =

FocusLock;module.exports = exports["default"];

/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
  attach: function attach() {},
  detach: function detach() {} };module.exports = exports["default"];

/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.parentAutofocusables = exports.getAllTabbableNodes = exports.getTabbableNodes = exports.filterFocusable = exports.getCommonParent = exports.notHiddenInput = exports.isVisible = undefined;var _tabOrder = __webpack_require__(1028);
var _tabUtils = __webpack_require__(1029);
var _array = __webpack_require__(976);

var isElementHidden = function isElementHidden(computedStyle) {
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};

var isVisible = exports.isVisible = function isVisible(node) {
  return !node || node === document || node.nodeType === Node.DOCUMENT_NODE || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
};

var notHiddenInput = exports.notHiddenInput = function notHiddenInput(node) {
  return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
};

var getParents = function getParents(node) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode, parents);
  }
  return parents;
};

var getCommonParent = exports.getCommonParent = function getCommonParent(nodea, nodeb) {
  var parentsA = getParents(nodea);
  var parentsB = getParents(nodeb);

  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};

var filterFocusable = exports.filterFocusable = function filterFocusable(nodes) {
  return (0, _array.toArray)(nodes).filter(function (node) {
    return isVisible(node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};

var getTabbableNodes = exports.getTabbableNodes = function getTabbableNodes(topNodes, withGuards) {
  return (0, _tabOrder.orderByTabIndex)(filterFocusable((0, _tabUtils.getFocusables)(topNodes, withGuards)), true, withGuards);
};

var getAllTabbableNodes = exports.getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
  return (0, _tabOrder.orderByTabIndex)(filterFocusable((0, _tabUtils.getFocusables)(topNodes)), false);
};

var parentAutofocusables = exports.parentAutofocusables = function parentAutofocusables(topNode) {
  return filterFocusable((0, _tabUtils.getParentAutofocusables)(topNode));
};

/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.orderByTabIndex = exports.tabSort = undefined;var _array = __webpack_require__(976);

var tabSort = exports.tabSort = function tabSort(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;

  if (tabDiff) {
    if (!a.tabIndex) return 1;
    if (!b.tabIndex) return -1;
  }

  return tabDiff || indexDiff;
};

var orderByTabIndex = exports.orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
  return (0, _array.toArray)(nodes).map(function (node, index) {
    return {
      node: node,
      index: index,
      tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex };

  }).filter(function (data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getParentAutofocusables = exports.getFocusables = undefined;var _tabbables = __webpack_require__(1030);var _tabbables2 = _interopRequireDefault(_tabbables);
var _array = __webpack_require__(976);
var _constants = __webpack_require__(983);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var queryTabbables = _tabbables2.default.join(',');
var queryGuardTabbables = queryTabbables + ', [data-focus-guard]';

var getFocusables = exports.getFocusables = function getFocusables(parents, withGuards) {
  return parents.reduce(function (acc, parent) {
    return acc.concat(
    // add all tabbables inside
    (0, _array.toArray)(parent.querySelectorAll(withGuards ? queryGuardTabbables : queryTabbables)),
    // add if node is tabble itself
    parent.parentNode ? (0, _array.toArray)(parent.parentNode.querySelectorAll(_tabbables2.default.join(','))).filter(function (node) {
      return node === parent;
    }) : []);
  }, []);
};

var getParentAutofocusables = exports.getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll('[' + _constants.FOCUS_AUTO + ']');
  return (0, _array.toArray)(parentFocus).map(function (node) {
    return getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = ['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]'];module.exports = exports['default'];

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    if (isRadio(nodes[0]) && nodes[0].name) {
      return findSelectedRadio(nodes[0], nodes);
    }
  }
  return nodes[0];
};

var pickFocusable = exports.pickFocusable = function pickFocusable(nodes, index) {
  if (nodes.length > 1) {
    if (isRadio(nodes[index]) && nodes[index].name) {
      return nodes.indexOf(findSelectedRadio(nodes[index], nodes));
    }
  }
  return index;
};exports.default =

pickFirstFocus;

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _allAffected = __webpack_require__(989);var _allAffected2 = _interopRequireDefault(_allAffected);
var _array = __webpack_require__(976);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInsideIframe = function focusInsideIframe(topNode) {
  return !!(0, _array.arrayFind)((0, _array.toArray)(topNode.querySelectorAll('iframe')), focusInFrame);
};

var focusInside = function focusInside(topNode) {
  var activeElement = document && document.activeElement;

  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return (0, _allAffected2.default)(topNode).reduce(function (result, node) {
    return result || node.contains(activeElement) || focusInsideIframe(node);
  }, false);
};exports.default =

focusInside;module.exports = exports['default'];

/***/ }),

/***/ 1033:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _array = __webpack_require__(976);
var _constants = __webpack_require__(983);

var focusIsHidden = function focusIsHidden() {
  return document && (0, _array.toArray)(document.querySelectorAll('[' + _constants.FOCUS_ALLOW + ']')).some(function (node) {
    return node.contains(document.activeElement);
  });
};exports.default =

focusIsHidden;module.exports = exports['default'];

/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.focusOn = undefined;var _focusMerge = __webpack_require__(1000);var _focusMerge2 = _interopRequireDefault(_focusMerge);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var focusOn = exports.focusOn = function focusOn(target) {
  target.focus();
  if (target.contentWindow) {
    target.contentWindow.focus();
  }
};

var guardCount = 0;
var lockDisabled = false;exports.default =

function (topNode, lastNode) {
  var focusable = (0, _focusMerge2.default)(topNode, lastNode);

  if (lockDisabled) {
    return;
  }

  if (focusable) {
    if (guardCount > 2) {
      // eslint-disable-next-line no-console
      console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
      lockDisabled = true;
      setTimeout(function () {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node);
    guardCount--;
  }
};

/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.onFocus = exports.onBlur = undefined;var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactClientsideEffect = __webpack_require__(1036);var _reactClientsideEffect2 = _interopRequireDefault(_reactClientsideEffect);
var _focusLock = __webpack_require__(980);var _focusLock2 = _interopRequireDefault(_focusLock);
var _util = __webpack_require__(984);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || (0, _focusLock.focusIsHidden)();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement };

};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
    observed = _lastActiveTrap.observed,
    persistentFocus = _lastActiveTrap.persistentFocus,
    autoFocus = _lastActiveTrap.autoFocus,
    shards = _lastActiveTrap.shards;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutsideWindow || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !((0, _focusLock.focusInside)(workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              activeElement.blur();
              document.body.focus();
            } else {
              result = (0, _focusLock2.default)(workingArea, lastActiveFocus);
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = (0, _focusLock.getFocusabledIn)(workingArea);
        var focusedItem = allNodes.find(function (_ref) {
          var node = _ref.node;
          return node === newActiveElement;
        });

        if (focusedItem) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
            node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          var focusedIndex = allNodes.indexOf(focusedItem);
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = exports.onBlur = function onBlur() {
  return (0, _util.deferAction)(activateTrap);
};
var onFocus = exports.onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return _react2.default.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus },
  children);
};

FocusTrap.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired } :
{};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = true;
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap, true);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap, true);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  }).slice(-1)[0];
}

function handleStateChangeOnClient(trap) {
  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.onActivation === lastTrap.onActivation;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap(true);
    (0, _util.deferAction)(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}exports.default =

(0, _reactClientsideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _inheritsLoose2 = __webpack_require__(1037);var _inheritsLoose3 = _interopRequireDefault(_inheritsLoose2);
var _defineProperty2 = __webpack_require__(1038);var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }

    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      (0, _inheritsLoose3.default)(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.PureComponent);

    (0, _defineProperty3.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}exports.default =

withSideEffect;module.exports = exports['default'];

/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _create = __webpack_require__(222);var _create2 = _interopRequireDefault(_create);exports.default = _inheritsLoose;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _inheritsLoose(subClass, superClass) {
  subClass.prototype = (0, _create2.default)(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}module.exports = exports["default"];

/***/ }),

/***/ 1038:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault(_defineProperty2);exports.default = _defineProperty;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _defineProperty(obj, key, value) {
  if (key in obj) {
    (0, _defineProperty3.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true });

  } else {
    obj[key] = value;
  }

  return obj;
}module.exports = exports["default"];

/***/ }),

/***/ 1039:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(982);var _extends3 = _interopRequireDefault(_extends2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusLock = __webpack_require__(980);
var _util = __webpack_require__(984);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
  children = _ref.children,
  className = _ref.className;
  return _react2.default.createElement("div", (0, _extends3.default)({}, (0, _util.inlineProp)(_focusLock.constants.FOCUS_AUTO, !disabled), {
    className: className }),
  children);
};

AutoFocusInside.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string } :
{};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined };exports.default =

AutoFocusInside;module.exports = exports['default'];

/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = undefined;var _extends2 = __webpack_require__(982);var _extends3 = _interopRequireDefault(_extends2);
var _inheritsLoose2 = __webpack_require__(997);var _inheritsLoose3 = _interopRequireDefault(_inheritsLoose2);
var _assertThisInitialized2 = __webpack_require__(998);var _assertThisInitialized3 = _interopRequireDefault(_assertThisInitialized2);
var _defineProperty2 = __webpack_require__(999);var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusLock = __webpack_require__(980);var _focusLock2 = _interopRequireDefault(_focusLock);
var _util = __webpack_require__(984);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var MoveFocusInside =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose3.default)(MoveFocusInside, _Component);

  function MoveFocusInside() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "setObserveNode", function (ref) {
      _this.observed = ref;

      _this.moveFocus();
    });

    return _this;
  }

  var _proto = MoveFocusInside.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.moveFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.disabled && !this.props.disabled) {
      this.moveFocus();
    }
  };

  _proto.moveFocus = function moveFocus() {
    var observed = this.observed;

    if (!this.props.disabled && observed) {
      if (!(0, _focusLock.focusInside)(observed)) {
        (0, _focusLock2.default)(observed, null);
      }
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
    children = _this$props.children,
    disabled = _this$props.disabled,
    className = _this$props.className;
    return _react2.default.createElement("div", (0, _extends3.default)({}, (0, _util.inlineProp)(_focusLock.constants.FOCUS_AUTO, !disabled), {
      ref: this.setObserveNode,
      className: className }),
    children);
  };

  return MoveFocusInside;
}(_react.Component);

(0, _defineProperty3.default)(MoveFocusInside, "defaultProps", {
  disabled: false,
  className: undefined });exports.


default = MoveFocusInside;
MoveFocusInside.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string } :
{};module.exports = exports["default"];

/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(982);var _extends3 = _interopRequireDefault(_extends2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusLock = __webpack_require__(980);
var _util = __webpack_require__(984);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var FreeFocusInside = function FreeFocusInside(_ref) {
  var children = _ref.children,
  className = _ref.className;
  return _react2.default.createElement("div", (0, _extends3.default)({}, (0, _util.inlineProp)(_focusLock.constants.FOCUS_ALLOW, true), {
    className: className }),
  children);
};

FreeFocusInside.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string } :
{};
FreeFocusInside.defaultProps = {
  disabled: false,
  className: undefined };exports.default =

FreeFocusInside;module.exports = exports['default'];

/***/ }),

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1043);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1044);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1044:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._3bPc2GOh{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.XpEl3ZjJ{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}.XpEl3ZjJ,.XpEl3ZjJ span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.XpEl3ZjJ span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}.XpEl3ZjJ:hover span{background:#30379d}.XpEl3ZjJ:focus{border-color:#30379d;outline:none}.XpEl3ZjJ:focus span{background:#30379d}.XpEl3ZjJ.PVJYaOFd{cursor:not-allowed}.XpEl3ZjJ.PVJYaOFd span{background:#f4f4f8;color:#6e6e77}.XpEl3ZjJ._1Czu0JVU{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}.XpEl3ZjJ._2Pc4XXN9 span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}.XpEl3ZjJ._2Pc4XXN9:hover span{background:#f4f4f8}.XpEl3ZjJ._2Pc4XXN9:focus{border-color:#30379d}.XpEl3ZjJ._2Pc4XXN9.PVJYaOFd{cursor:not-allowed}.XpEl3ZjJ._2Pc4XXN9.PVJYaOFd span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.XpEl3ZjJ.Hu2rpqNE span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}.XpEl3ZjJ.Hu2rpqNE span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}.XpEl3ZjJ.Hu2rpqNE:hover span{background:#f4f4f8}.XpEl3ZjJ.Hu2rpqNE:focus{border-color:#30379d}.XpEl3ZjJ.Hu2rpqNE.PVJYaOFd{cursor:not-allowed}.XpEl3ZjJ.Hu2rpqNE.PVJYaOFd span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.XpEl3ZjJ._39xSEMm6 span{background:transparent;color:#414141;letter-spacing:.36px}.XpEl3ZjJ._39xSEMm6:hover span{background:#f4f4f8}.XpEl3ZjJ._39xSEMm6:focus{border-color:#30379d}.XpEl3ZjJ._39xSEMm6:focus span{background:#f4f4f8}.XpEl3ZjJ._39xSEMm6.PVJYaOFd{cursor:not-allowed}.XpEl3ZjJ._39xSEMm6.PVJYaOFd span{background:#f4f4f8;color:#6e6e77}._3eNtlD5k{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}._3eNtlD5k._1assUFYp:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}._3Z4qQhFz{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}._3Z4qQhFz,._3Z4qQhFz span{display:inline-block}._3Z4qQhFz span._1Riw2Ywo{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}._3Z4qQhFz span._1VrVSXiS{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}._3Z4qQhFz span._1VrVSXiS:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}._3Z4qQhFz span._1VrVSXiS._3F2aUG9H:after{content:\"\\E5CF\"}._3Z4qQhFz span._1VrVSXiS._1sfJBO0P:after{content:\"\\E5CE\"}._3Z4qQhFz:focus{outline-color:#4b55f6}.XpEl3ZjJ._20N4h0JV{border-radius:50%;width:40px;height:40px;position:relative}.XpEl3ZjJ._20N4h0JV span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}.XpEl3ZjJ._20N4h0JV span,.XpEl3ZjJ._20N4h0JV span:after{color:#4b55f6;display:inline-block;position:relative}.XpEl3ZjJ._20N4h0JV span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.XpEl3ZjJ._20N4h0JV:hover span{background:#f4f4f8}.XpEl3ZjJ._20N4h0JV:focus{border-color:#4b55f6}.XpEl3ZjJ._20N4h0JV:focus span{background:#f4f4f8}.XpEl3ZjJ._20N4h0JV.PVJYaOFd span{background:#f4f4f8;color:#6e6e77}.XpEl3ZjJ._20N4h0JV._2ByhCNmW span:after{content:\"\\E7FD\"}.XpEl3ZjJ._20N4h0JV._3L9rGssS span:after{content:\"\\F233\"}.XpEl3ZjJ._20N4h0JV._4FYBQwIQ span:after{content:\"\\F1CF\"}.XpEl3ZjJ._20N4h0JV._2F6h4iZx span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._3c4IQLuG span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV.wJBX2P7_ span:after{content:\"\\E86C\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV.QwFEJ6WC span:after{content:\"\\E876\"}.XpEl3ZjJ._20N4h0JV._2EnFcVjp span:after{content:\"\\E835\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._2dN1QmWD span:after{content:\"\\E834\"}.XpEl3ZjJ._20N4h0JV._2bK066JS span:after{content:\"\\E5CF\"}.XpEl3ZjJ._20N4h0JV._2g1Z4Vup span:after{content:\"\\E5CE\"}.XpEl3ZjJ._20N4h0JV._1yAFwdcE span:after{content:\"\\E5CD\"}.XpEl3ZjJ._20N4h0JV._2aqdCTcO span:after{content:\"\\E0C6\"}.XpEl3ZjJ._20N4h0JV._3LBJbCsL span:after{content:\"\\E5D4\"}.XpEl3ZjJ._20N4h0JV._3B3m4ALJ span:after{content:\"\\E880\"}.XpEl3ZjJ._20N4h0JV._3TCuGBtK span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._3Ir5nPnJ span:after{content:\"\\E87D\"}.XpEl3ZjJ._20N4h0JV.ojEeHgIS span:after{content:\"\\E87E\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._1O0pDCKo span:after{content:\"\\E41A\"}.XpEl3ZjJ._20N4h0JV._2mxBOlOy span:after{content:\"\\E8B6\"}.XpEl3ZjJ._20N4h0JV._3zPTZtIZ span:after{content:\"\\E0B7\"}.XpEl3ZjJ._20N4h0JV._10IWBZp5 span:after{content:\"\\E150\"}.XpEl3ZjJ._20N4h0JV._10Tve6qv span:after{content:\"\\E150\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._1vBKFS5y span:after{content:\"\\E145\"}.XpEl3ZjJ._20N4h0JV._1oASSyv4 span:after{content:\"\\E836\"}.XpEl3ZjJ._20N4h0JV.BBCqpwnX span:after{content:\"\\E837\"}.XpEl3ZjJ._20N4h0JV._2ukikiYE span:after{content:\"\\E163\"}.XpEl3ZjJ._20N4h0JV.-oWjpsCR span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._1fJJiHWq span:after{content:\"\\E872\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._3I-TN97x span:after{content:\"\\E5C4\"}.XpEl3ZjJ._20N4h0JV._1y9PUXZP span:after{content:\"\\E5C8\"}.XpEl3ZjJ._20N4h0JV._1bpi1_YF,.XpEl3ZjJ._20N4h0JV._2LB8_HOG{background:transparent;border-radius:0;color:#414141;padding:0;height:28px;width:28px}.XpEl3ZjJ._20N4h0JV._1bpi1_YF span,.XpEl3ZjJ._20N4h0JV._2LB8_HOG span{padding:0;height:24px;width:24px}.XpEl3ZjJ._20N4h0JV._1bpi1_YF span:after,.XpEl3ZjJ._20N4h0JV._2LB8_HOG span:after{color:#414141}.XpEl3ZjJ._20N4h0JV._1bpi1_YF._2r3md3gs,.XpEl3ZjJ._20N4h0JV._1bpi1_YF._2r3md3gs span:after,.XpEl3ZjJ._20N4h0JV._2LB8_HOG._2r3md3gs,.XpEl3ZjJ._20N4h0JV._2LB8_HOG._2r3md3gs span:after{color:#4b55f6}.XpEl3ZjJ._20N4h0JV._1bpi1_YF span:after{content:\"\\E8EF\"}.XpEl3ZjJ._20N4h0JV._2LB8_HOG span:after{content:\"\\E9B0\"}.XpEl3ZjJ._2P9lTtT2{position:relative;padding:0;border:none;border-radius:0}.XpEl3ZjJ._2P9lTtT2 span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}.XpEl3ZjJ._2P9lTtT2 span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}.XpEl3ZjJ._2P9lTtT2:hover span{background:#f4f4f8}.XpEl3ZjJ._2P9lTtT2._3LBJbCsL span:after{content:\"\\E5D4\"}.ZNMgkbk- ._1YMkOuDI{display:none}.ZNMgkbk- ._1YMkOuDI+._3oOdY5UJ{display:inline-block}.ZNMgkbk- ._1YMkOuDI+._3oOdY5UJ:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}.ZNMgkbk- ._1YMkOuDI:checked+._3oOdY5UJ:before{content:\"\\E834\"}.ZNMgkbk- span{padding-left:14px}._1lwlcUCf{display:block}._1lwlcUCf input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._1lwlcUCf input[type=radio]+._2SgCj7tq:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._1lwlcUCf input[type=radio]+._2SgCj7tq span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}._1lwlcUCf input[type=radio]:checked+._2SgCj7tq:before{content:\"\\E837\"}._1lwlcUCf input[type=radio]+._2SgCj7tq:empty:before{margin-right:0}", ""]);

// exports
exports.locals = {
	"material-icons": "_3bPc2GOh",
	"btn": "XpEl3ZjJ",
	"disabled": "PVJYaOFd",
	"user-btn": "_1Czu0JVU",
	"secondary-btn": "_2Pc4XXN9",
	"secondary-button_icon": "Hu2rpqNE",
	"ghost-btn": "_39xSEMm6",
	"btn-icon-text_back": "_3eNtlD5k",
	"icon_arrow-back": "_1assUFYp",
	"btn-type-dropdown": "_3Z4qQhFz",
	"default-header": "_1Riw2Ywo",
	"icon": "_1VrVSXiS",
	"icon_chevron-down": "_3F2aUG9H",
	"icon_chevron-up": "_1sfJBO0P",
	"icon-btn": "_20N4h0JV",
	"account": "_2ByhCNmW",
	"account_group": "_3L9rGssS",
	"collapse": "_4FYBQwIQ",
	"expand": "_2F6h4iZx",
	"arrow_right": "_3c4IQLuG",
	"check_circle": "wJBX2P7_",
	"check": "QwFEJ6WC",
	"checkbox_blank": "_2EnFcVjp",
	"checkbox_marked": "_2dN1QmWD",
	"chevron_down": "_2bK066JS",
	"chevron_up": "_2g1Z4Vup",
	"close": "_1yAFwdcE",
	"comment_question": "_2aqdCTcO",
	"dots_vertical": "_3LBJbCsL",
	"file_document_box": "_3B3m4ALJ",
	"filter": "_3TCuGBtK",
	"heart": "_3Ir5nPnJ",
	"heart_outline": "ojEeHgIS",
	"loading": "_1O0pDCKo",
	"magnify": "_2mxBOlOy",
	"message": "_3zPTZtIZ",
	"pencil": "_10IWBZp5",
	"pencil_outline": "_10Tve6qv",
	"plus": "_1vBKFS5y",
	"radiobox_blank": "_1oASSyv4",
	"radiobox_marked": "BBCqpwnX",
	"icon-send": "_2ukikiYE",
	"tooltip_text_outline": "-oWjpsCR",
	"trash_can_outline": "_1fJJiHWq",
	"icon_arrow-left": "_3I-TN97x",
	"icon_arrow-right": "_1y9PUXZP",
	"list": "_1bpi1_YF",
	"tile": "_2LB8_HOG",
	"active": "_2r3md3gs",
	"list-item-icon-btn": "_2P9lTtT2",
	"default-checkbox-div": "ZNMgkbk-",
	"default-checkbox": "_1YMkOuDI",
	"checkmark": "_3oOdY5UJ",
	"radio": "_1lwlcUCf",
	"radio-label": "_2SgCj7tq"
};

/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _getOwnPropertyDescriptor = __webpack_require__(652);var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);





var _react = __webpack_require__(648);
var _react2 = __webpack_require__(171);var _react3 = _interopRequireDefault(_react2);
var _reactFocusLock = __webpack_require__(991);var _reactFocusLock2 = _interopRequireDefault(_reactFocusLock);
var _launch = __webpack_require__(235);
var _styles = __webpack_require__(1077);var _styles2 = _interopRequireDefault(_styles);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {var c = arguments.length,r = c < 3 ? target : desc === null ? desc = (0, _getOwnPropertyDescriptor2.default)(target, key) : desc,d;if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof3.default)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;}return c > 3 && r && (0, _defineProperty2.default)(target, key, r), r;};
var Wrapper = function (_React$Component) {(0, _inherits3.default)(Wrapper, _React$Component);
    function Wrapper() {(0, _classCallCheck3.default)(this, Wrapper);var _this = (0, _possibleConstructorReturn3.default)(this, (Wrapper.__proto__ || (0, _getPrototypeOf2.default)(Wrapper)).apply(this,
        arguments));
        _this.thisButtonNo = _this.props.thisButtonNo;
        _this.thisButtonAction = _this.props.thisButtonAction;
        _this.onFocus = _this.props.onFocus;
        _this.ref = _react3.default.createRef();return _this;
    }(0, _createClass3.default)(Wrapper, [{ key: "componentDidMount", value: function componentDidMount()
        {
            if (_launch.hack.store.getState().notemenu.buttonNo === this.props.thisButtonNo &&
            _launch.hack.store.getState().notemenu.buttonAction === this.props.thisButtonAction) {
                {
                    if (this.props.updateAfterMount) {
                        this.forceUpdate();
                    }
                }
            }
        } }, { key: "componentDidUpdate", value: function componentDidUpdate()
        {
            if (this.props.updatedlock) {
                if (_launch.hack.store.getState().notemenu.buttonNo === this.props.thisButtonNo &&
                _launch.hack.store.getState().notemenu.buttonAction === this.props.thisButtonAction) {
                    if (this.ref) {
                        if (this.props.children) {
                            var reference = this.ref;
                            if (reference.focus) {
                                reference.focus();
                            }
                        } else
                        {
                            this.ref.current.focus();
                        }
                    }
                    this.props.custom(this.props.updatedlock());
                }
            }
        } }, { key: "render", value: function render()
        {var _this2 = this;
            var onFocus = this.props.onFocus;
            var childArray = [this.props.children];
            return _react3.default.createElement(_reactFocusLock2.default, { className: (0, _styles2.default)('focus-lock-style'), noFocusGuards: true, disabled: !(_launch.hack.store.getState().notemenu.buttonNo === this.props.thisButtonNo &&
                _launch.hack.store.getState().notemenu.buttonAction === this.props.thisButtonAction) },
            _react3.default.createElement("div", { tabIndex: -1, onFocus: onFocus, className: (0, _styles2.default)('wrapper-style') }, childArray !== undefined && childArray.length === 1 ?
            _react3.default.cloneElement(_react3.default.Children.only(this.props.children), { ref: function ref(el) {return _this2.ref = el;} }) :
            this.props.children));
        } }]);return Wrapper;}(_react3.default.Component);

Wrapper = __decorate([
(0, _react.Connect)(function (state) {return {
        buttonNo: state.notemenu ? state.notemenu.buttonNo : 0,
        buttonAction: state.buttonAction ? state.notemenu.buttonAction : undefined };},
function (dispatch) {return {
        custom: function custom(action) {dispatch(action);} };})],

Wrapper);exports.default =
Wrapper;

/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1078);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1079);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._2izfhFaB,._3xPCAvar{margin:0;padding:0;display:inline-block}", ""]);

// exports
exports.locals = {
	"focus-lock-style": "_2izfhFaB",
	"wrapper-style": "_3xPCAvar"
};

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1325);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1326);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._2EHzEyBE{display:-webkit-box;display:-ms-flexbox;display:flex;list-style-type:none;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2EHzEyBE._1NPBC9gE{padding:0;-webkit-padding-start:5px;-moz-padding-start:5px;padding-inline-start:5px}._2EHzEyBE._1NPBC9gE li{padding:0 2px}._2EHzEyBE._2hdU3auW{padding:0 11px 8px;-webkit-padding-start:40px;-moz-padding-start:40px;padding-inline-start:40px}._2EHzEyBE ._29dlv7SJ{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}._2EHzEyBE ._2PnmJ_0A{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}._3uEcovSG div span{font-size:18px;vertical-align:middle}._1VXTf1Re{line-height:34px;margin:8px 0;padding:0 8px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}", ""]);

// exports
exports.locals = {
	"component": "_2EHzEyBE",
	"small-section": "_1NPBC9gE",
	"big-section": "_2hdU3auW",
	"left": "_29dlv7SJ",
	"right": "_2PnmJ_0A",
	"icon-size": "_3uEcovSG",
	"section": "_1VXTf1Re"
};

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _for = __webpack_require__(520);var _for2 = _interopRequireDefault(_for);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                                                                                                                                                                                                                                        * Copyright (c) 2013-present, Facebook, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                        * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                        * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                                                                                                        */

if (false) {
  var REACT_ELEMENT_TYPE = typeof _symbol2.default === 'function' && _for2.default &&

  (0, _for2.default)('react.element') ||
  0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : (0, _typeof3.default)(object)) === 'object' &&
    object !== null &&
    object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1006)();
}

/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(648);
var _selectors = __webpack_require__(649);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(78);
var _selectors4 = __webpack_require__(975);var _selectors5 = _interopRequireDefault(_selectors4);
var _LOGIN = __webpack_require__(523);var _LOGIN2 = _interopRequireDefault(_LOGIN);
var _HIDE = __webpack_require__(543);var _HIDE2 = _interopRequireDefault(_HIDE);
var _BUTTON_HIDE_FLYOVER = __webpack_require__(705);var _BUTTON_HIDE_FLYOVER2 = _interopRequireDefault(_BUTTON_HIDE_FLYOVER);
var _SHOW = __webpack_require__(499);var _SHOW2 = _interopRequireDefault(_SHOW);
var _ERASE = __webpack_require__(558);var _ERASE2 = _interopRequireDefault(_ERASE);
var _SHOW3 = __webpack_require__(498);var _SHOW4 = _interopRequireDefault(_SHOW3);

var _style = __webpack_require__(1324);var _style2 = _interopRequireDefault(_style);
var _wrapper = __webpack_require__(1060);var _wrapper2 = _interopRequireDefault(_wrapper);
var _UPDATE_BUTTON_NO = __webpack_require__(519);
var _UPDATED_BUTTON_LOCK = __webpack_require__(665);var _UPDATED_BUTTON_LOCK2 = _interopRequireDefault(_UPDATED_BUTTON_LOCK);
var _button = __webpack_require__(973);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('NoteBar')(function (state) {return {
        admin: state.admin.visible,
        flyover: state.flyover.visible,
        loggedIn: _selectors2.default.loggedIn(state),
        notemenu: state.notemenu.visible,
        pageNumber: _selectors3.selectors.pageNumber(state),
        screenSmall: _selectors5.default.small(state) };},
function (dispatch) {return {
        closeAdminModal: function closeAdminModal() {return dispatch((0, _HIDE2.default)({}));},
        closeFlyOverModal: function closeFlyOverModal() {return dispatch((0, _BUTTON_HIDE_FLYOVER2.default)({}));},
        closeNoteServiceMenu: function closeNoteServiceMenu() {dispatch((0, _ERASE2.default)({}));},
        openFlyOverModal: function openFlyOverModal() {return dispatch((0, _SHOW2.default)({ buttonNo: _UPDATE_BUTTON_NO.buttonNoSelection, origin: _UPDATE_BUTTON_NO.originFlyover }));},
        requestLogin: function requestLogin() {return dispatch((0, _LOGIN2.default)({}));},
        showAdmin: function showAdmin() {
            dispatch((0, _SHOW4.default)({}));
        },
        closeAdmin: function closeAdmin() {
            dispatch((0, _HIDE2.default)({}));
        } };},
function (_ref) {var loggedIn = _ref.loggedIn,admin = _ref.admin,flyover = _ref.flyover,notemenu = _ref.notemenu,screenSmall = _ref.screenSmall,requestLogin = _ref.requestLogin,openFlyOverModal = _ref.openFlyOverModal,closeFlyOverModal = _ref.closeFlyOverModal,closeAdmin = _ref.closeAdmin,showAdmin = _ref.showAdmin,closeNoteServiceMenu = _ref.closeNoteServiceMenu;
    if (!loggedIn) {
        return _react.React.createElement("div", { className: (0, _style2.default)('component', 'section', screenSmall ? 'small-section' : 'big-section') },
        _react.React.createElement("div", { className: (0, _style2.default)('left') },
        _react.React.createElement(_wrapper2.default, { thisButtonNo: _UPDATE_BUTTON_NO.buttonLogin, updatedlock: function updatedlock() {return (0, _UPDATED_BUTTON_LOCK2.default)({ buttonNo: _UPDATE_BUTTON_NO.buttonLogin, origin: _UPDATE_BUTTON_NO.originUndefined });} },
        _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Login notitieservice', "aria-pressed": false, "aria-expanded": false, "aria-haspopup": false, tabIndex: 0, onClick: function onClick() {return requestLogin();}, disabled: false },
        _react.React.createElement("span", null, "Login notitieservice")))));
    }
    {
    }
    var toggleButton = _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Mijn items', "aria-pressed": admin, "aria-expanded": admin, "aria-haspopup": true, tabIndex: 0, onClick: function onClick() {admin ? closeAdmin() : showAdmin();}, disabled: false },
    _react.React.createElement("span", null, "Mijn items"));
    var showHideBtn = _react.React.createElement(_wrapper2.default, { thisButtonNo: _UPDATE_BUTTON_NO.buttonBekijkItems, updatedlock: function updatedlock() {return (0, _UPDATED_BUTTON_LOCK2.default)({ buttonNo: _UPDATE_BUTTON_NO.buttonBekijkItems, origin: _UPDATE_BUTTON_NO.originNoteMenu });}, onFocus: closeNoteServiceMenu },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Bekijk items', "aria-pressed": flyover, "aria-expanded": flyover, "aria-haspopup": true, tabIndex: 0, onClick: function onClick() {flyover ? closeFlyOverModal() : openFlyOverModal();}, disabled: false },
    _react.React.createElement("span", null, flyover ? 'Verbergen' : 'Notities weergeven')));
    return _react.React.createElement("ul", { className: (0, _style2.default)('component', screenSmall ? 'small-section' : 'big-section') },
    _react.React.createElement("li", { className: (0, _style2.default)('left', 'section') }, toggleButton),
    _react.React.createElement("li", { className: (0, _style2.default)('right', 'section') }, admin ? null :
    showHideBtn));
});

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.Btn = undefined;var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _button = __webpack_require__(1042);var _button2 = _interopRequireDefault(_button);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
Btn = exports.Btn = function (_React$Component) {(0, _inherits3.default)(Btn, _React$Component);
    function Btn() {(0, _classCallCheck3.default)(this, Btn);var _this = (0, _possibleConstructorReturn3.default)(this, (Btn.__proto__ || (0, _getPrototypeOf2.default)(Btn)).apply(this,
        arguments));
        _this.className = _this.props.className;
        _this.type = _this.props.type;
        _this.role = _this.props.role;
        _this.disabled = _this.props.disabled;
        _this.extraClassNames = _this.props.extraClassNames ? _this.props.extraClassNames : [];
        _this.arialabel = _this.props['aria-label'];
        _this.ariahaspopup = _this.props['has-popup'];
        _this.tabIndex = _this.props.tabIndex;
        _this.allClassNames = [];return _this;
    }(0, _createClass3.default)(Btn, [{ key: 'render', value: function render()
        {var _this2 = this;
            this.allClassNames = [this.className];
            if (this.extraClassNames)
            this.allClassNames = this.allClassNames.concat(this.extraClassNames);
            if (this.props.disabled)
            this.allClassNames = this.allClassNames.concat('disabled');
            var button = _react2.default.createElement("button", { type: this.type, role: this.role, disabled: this.props.disabled, tabIndex: this.tabIndex, "aria-label": this.arialabel, "aria-haspopup": this.ariahaspopup, className: (0, _button2.default)(this.allClassNames), onClick: function onClick() {return _this2.props.onClick();} }, this.props.children);
            return button;
        } }]);return Btn;}(_react2.default.Component);

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _reselect = __webpack_require__(221);
var _reducer = __webpack_require__(661);
var smallScreenSize = 800;exports.default =
{
    dimensions: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state;}),
    landscape: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.width > state.height;}),
    portrait: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.width <= state.height;}),
    small: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.width <= smallScreenSize;}),
    width: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.width;}),
    height: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.height;}) };

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var toArray = exports.toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};

var arrayFind = exports.arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};

var asArray = exports.asArray = function asArray(a) {
  return Array.isArray(a) ? a : [a];
};

/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getAllAffectedNodes = exports.constants = exports.getFocusabledIn = exports.focusMerge = exports.focusIsHidden = exports.focusInside = exports.tabHook = undefined;var _tabHook = __webpack_require__(1026);var _tabHook2 = _interopRequireDefault(_tabHook);
var _focusMerge = __webpack_require__(1000);var _focusMerge2 = _interopRequireDefault(_focusMerge);
var _focusInside = __webpack_require__(1032);var _focusInside2 = _interopRequireDefault(_focusInside);
var _focusIsHidden = __webpack_require__(1033);var _focusIsHidden2 = _interopRequireDefault(_focusIsHidden);
var _setFocus = __webpack_require__(1034);var _setFocus2 = _interopRequireDefault(_setFocus);
var _constants = __webpack_require__(983);var constants = _interopRequireWildcard(_constants);
var _allAffected = __webpack_require__(989);var _allAffected2 = _interopRequireDefault(_allAffected);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.

tabHook = _tabHook2.default;exports.focusInside = _focusInside2.default;exports.focusIsHidden = _focusIsHidden2.default;exports.focusMerge = _focusMerge2.default;exports.getFocusabledIn = _focusMerge.getFocusabledIn;exports.constants = constants;exports.getAllAffectedNodes = _allAffected2.default;exports.default = _setFocus2.default;

/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _extends() {
  module.exports = _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var FOCUS_GROUP = exports.FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = exports.FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = exports.FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = exports.FOCUS_AUTO = 'data-autofocus-inside';

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.deferAction = deferAction;function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var setImmediate = window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
var inlineProp = exports.inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);

var _constants = __webpack_require__(983);
var _array = __webpack_require__(976);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};

var filterNested = function filterNested(nodes) {
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    var _loop = function _loop(j) {
      if (i !== j) {
        if (nodes[i].contains(nodes[j])) {
          return {
            v: filterNested(nodes.filter(function (x) {
              return x !== nodes[j];
            })) };

        }
      }
    };

    for (var j = 0; j < l; j += 1) {
      var _ret = _loop(j);

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  }
  return nodes;
};

var getTopParent = function getTopParent(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};

var getAllAffectedNodes = function getAllAffectedNodes(node) {
  var nodes = (0, _array.asArray)(node);
  return nodes.filter(Boolean).reduce(function (acc, currentNode) {
    var group = currentNode.getAttribute(_constants.FOCUS_GROUP);
    acc.push.apply(acc, group ? filterNested((0, _array.toArray)(getTopParent(currentNode).querySelectorAll('[' + _constants.FOCUS_GROUP + '="' + group + '"]:not([' + _constants.FOCUS_DISABLED + '="disabled"])'))) : [currentNode]);
    return acc;
  }, []);
};exports.default =

getAllAffectedNodes;module.exports = exports["default"];

/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.InFocusGuard = exports.FreeFocusInside = exports.MoveFocusInside = exports.AutoFocusInside = undefined;var _Lock = __webpack_require__(1025);var _Lock2 = _interopRequireDefault(_Lock);
var _AutoFocusInside = __webpack_require__(1039);var _AutoFocusInside2 = _interopRequireDefault(_AutoFocusInside);
var _MoveFocusInside = __webpack_require__(1040);var _MoveFocusInside2 = _interopRequireDefault(_MoveFocusInside);
var _FreeFocusInside = __webpack_require__(1041);var _FreeFocusInside2 = _interopRequireDefault(_FreeFocusInside);
var _FocusGuard = __webpack_require__(1001);var _FocusGuard2 = _interopRequireDefault(_FocusGuard);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.
AutoFocusInside = _AutoFocusInside2.default;exports.MoveFocusInside = _MoveFocusInside2.default;exports.FreeFocusInside = _FreeFocusInside2.default;exports.InFocusGuard = _FocusGuard2.default;exports.default = _Lock2.default;

/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _create = __webpack_require__(222);var _create2 = _interopRequireDefault(_create);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _inheritsLoose(subClass, superClass) {
  subClass.prototype = (0, _create2.default)(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault(_defineProperty2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _defineProperty(obj, key, value) {
  if (key in obj) {
    (0, _defineProperty3.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true });

  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ })

});


// WEBPACK FOOTER //
// 3.js